export const TOGGLE = {
    CARD: 'card',
    LIST: 'list'
};
